<script setup lang="ts" generic="TParams extends any[]">
import Button from 'primevue/button';
import { useAbilityWithParams } from '../composables/useAbility';
import { computed } from 'vue';
import type {
    Ability,
    AsyncAbility,
} from '@precon-tools-suite-by-shared/shared-auth-js-ability-checks';

const props = withDefaults(
    defineProps<{
        ability: Ability<TParams> | AsyncAbility<TParams>;
        parameters: TParams;
        whenLocked?: 'hide' | 'disable' | 'nothing';
        loading?: boolean;
        disabled?: boolean;
    }>(),
    {
        whenLocked: 'disable',
        loading: false,
        disabled: false,
    }
);

const { allowed, loading: abilityLoading } = useAbilityWithParams(
    props.ability,
    props.parameters
);

const locked = computed(() => !abilityLoading.value && !allowed.value);
</script>

<template>
    <Button
        v-if="!(whenLocked === 'hide' && (locked || abilityLoading))"
        :loading="loading || abilityLoading"
        :disabled="disabled || (whenLocked === 'disable' && locked)"
        v-bind="$attrs"
    />
</template>
